import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import TenderRadar from "@/pages/TenderRadar";
import Projects from "@/pages/Projects";
import LabourManager from "@/pages/LabourManager";
import FinanceTracker from "@/pages/FinanceTracker";
import DocumentVault from "@/pages/DocumentVault";
import Settings from "@/pages/Settings";
import AppLayout from "@/components/AppLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("contractor_os_token");
  if (!token) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
    <div className="App">
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/app/*"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/tenders" element={<TenderRadar />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/labour" element={<LabourManager />} />
                    <Route path="/finance" element={<FinanceTracker />} />
                    <Route path="/documents" element={<DocumentVault />} />
                    <Route path="/settings" element={<Settings />} />
                  </Routes>
                </AppLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#111110',
            border: '1px solid #27272A',
            color: '#F5F2E8',
          },
        }}
      />
    </div>
    </ErrorBoundary>
  );
}

export default App;
